<template>
  <!-- 产品包列表 author: zhangxiaofeng  -->
  <ul class="package-tree">
    <li :class="[fold ? 'fold-children' : '', 'li-level-' + level]">
      <package-instance :item="listData" :level="level"
                        :search-condition="searchCondition"
                        @foldHandle="triggerFold"
                        :is-leaf="children.length === 0">
      </package-instance>
      <template v-if="children && children.length > 0">
        <package-list v-for="(childItem, idx) in children"
                      :search-condition="searchCondition"
                      :key="'package-list-' + level + '-' + idx"
                      :list-data="childItem" :level="level + 1">
        </package-list>
      </template>
    </li>
  </ul>
</template>
<style lang="less" type="text/less">
  .package-tree{
    display: block;
  }
  .fold-children{
    &>.package-tree{
      display: none;
    }
  }
</style>
<script>
import PackageInstance from './PackageInstance'
export default {
  name: 'PackageList',
  props: {
    listData: {
      type: Array,
      default: () => []
    },
    level: {
      type: Number,
      default: 1
    },
    searchCondition: { // 产品名称过滤条件
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      fold: true // 菜单是否折叠
    }
  },
  computed: {
    children () {
      let list = []
      if (this.listData.children && this.listData.children.length) {
        list = this.listData.children
      } else if (this.listData.productInstanceList && this.listData.productInstanceList.length) {
        list = this.listData.productInstanceList
      }
      return list
    }
  },
  methods: {
    triggerFold (value) {
      this.fold = value
    }
  },
  components: {
    PackageInstance
  }
}
</script>
